import { Base } from "./Base";
import { Partner } from "./Partner";
import { Product } from "./Product";
import { City } from "./City";
import { Warehouse } from "./Warehouse";

export enum RequestType {
  Import = "IMPORT",
  Export = "EXPORT",
  Relocation = "RELOCATION",
}

export interface Request extends Base {
  id: string; // PK

  type?: RequestType;
  date?: Date;
  requestYear?: number;
  requestNumber?: number;
  requestNumberFormatted?: string;
  partner?: Partner;
  product?: Product;
  repromaterialRequestProducts?: Product[];
  repromaterialRequestProductsJSON?: string;
  year?: number;
  place?: string;
  address?: string;
  inputCity?: City;
  inputWarehouse?: Warehouse;
  note?: string;
  amount?: number;
  transportCost?: boolean;
  requestConfirmed?: boolean;
  completedRequest?: boolean;
  commercialistApproved?: boolean;
  backofficeApproved?: boolean;
  contact?: string;
}

export interface RequestShort extends Base {
  id: string;
  type: string;
  isRequestFinished: boolean;
  date: Date;
  requestYear?: number;
  requestNumber?: number;
  requestNumberFormatted?: string;
  productId?: string;
  productName?: string;
  year?: number;
  partnerId?: string;
  partnerName?: string;
  partnerCommercialist?: string;
  categoryId?: number;
  place?: string;
  warehouseId: string;
  warehouseName: string;
  note?: string;
  amount?: number;
  transportCost?: boolean;
  reproProducts?: string;
  reproAmounts?: string;
  reproNotes?: string;
  commercialistApproved?: boolean;
  backofficeApproved?: boolean;
  isDispositions?: boolean;
  contact?: string;
}
